import React from "react";
import { Button, Typography, Paper, Grid, Box, Card, CardContent, Divider } from "@material-ui/core";
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import { withRouter } from "react-router";
import Cookies from "js-cookie";
import results from "./data/results.json";
import cards from "./data/cards.json";

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

let card_style = {
  height: "100%",
  backgroundColor: "#fff"
}


/**
 * 結果表示
 */
class Result extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      result: Cookies.get("k-mental-first") || "?",
      result2: Cookies.get("k-mental-second") || "?"
    }
    console.log(Cookies.get("k-mental-first"));
  }


  renderNextButton() {
    if (this.state.result2 != "?") {
      return <Button variant="contained" color="primary" onClick={() => {
        this.props.history.push("/Result2");
      }}>気持ちのチェックリスト 結果へ</Button>
    }
    return <Button variant="contained" color="primary" onClick={() => {
      this.props.history.push("/Second");
    }}>もっと詳しく今の状態が知りたい</Button>
  }

  /**
   * 結果表示
   * @param {*} i
   */
  renderResult(i) {
    return (
      <div>
        <Box p={1}>
          <Typography variant="h4">{results[i].title}の特徴</Typography>
          <Typography variant="body1">{results[i].text}</Typography>
        </Box>
        <Box p={1}>
          <Typography variant="h4">あなたへのアドバイス</Typography>
          <Typography variant="body1">{results[i].result}</Typography>
        </Box>
      </div>
    )
  }

  /**
   * Card表示
   * @param {*} type
   * @param {*} title
   * @param {*} text
   */
  renderCard(type, title, text) {
    return (
      <Grid item xs={11} sm={4} md={3} lg={3} >
        <Card style={card_style}>
          <CardContent>
            <Typography variant="h6">[{type}]{title}</Typography>
            <Typography variant="body2">{text}</Typography>
          </CardContent>
        </Card>
      </Grid>
    )
  }

  render() {
    const result = this.state.result;
    var card_list = cards[result].map((i) => { return this.renderCard(i.type, i.title, i.text) });
    return (
      <ThemeProvider theme={theme}>
        <Grid container alignItems="center" justify="center">
          <Grid item xs={11}>
            <Box p={1}>
              <Paper>
                <Box p={2}>

                  <Typography variant="h4">結果 {results[this.state.result].title}</Typography>
                  <Typography variant="caption">人はストレスをどのように受け止めるかによってそれぞれのストレス反応が異なると言われています。ストレスの元（ストレッサー）にうまく対処しようとすることを、ストレスコーピングといいます。ストレッサーによって過剰なストレスが慢性的にかかると心身への様々な悪影響が考えられるため、健康を維持するにはうまくストレスコーピングすることが必要になります。</Typography>
                  {this.renderResult(result)}

                </Box>
              </Paper>
            </Box>
            <Box p={1}>
              <Typography className="paper_back" variant="h3">あなたへのお勧め</Typography>
              <Box p={1}></Box>
              <Grid container alignContent="stretch" justify="center" spacing={2}>
                {card_list}
              </Grid>
            </Box>
            <Box p={1}>
              <Paper>
                <Box p={1}>
                  <Grid container justify="center" spacing={1}>
                    <Grid item>
                      {this.renderNextButton()}
                    </Grid><Grid item>
                      <Button variant="contained" color="primary" href="https://docs.google.com/forms/d/e/1FAIpQLSe6b5ND0i88MxgkOedbgf0gKrMkYy14VAOxHZgHArd0QBoBRQ/viewform?usp=sf_link">終了して事後アンケートへ</Button>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </ThemeProvider>

    );
  }
}

export default withRouter(Result);
